import React from 'react';

type KoobPromptSuggestionProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'className' | 'type'
>;

/**
 * A suggested question to send to an assistant in one click: a bordered card
 * (the UI kit's assistant). Stack them in a column.
 */
const KoobPromptSuggestion = React.forwardRef<
  HTMLButtonElement,
  KoobPromptSuggestionProps
>(({ children, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className="w-full cursor-pointer rounded-xl border-[1.5px] border-solid border-k-gray bg-white px-3.5 py-3 text-left text-sm font-medium text-k-h transition-colors hover:border-navy-200 hover:bg-navy-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-k-h disabled:cursor-not-allowed disabled:opacity-50"
    {...props}
  >
    {children}
  </button>
));

KoobPromptSuggestion.displayName = 'KoobPromptSuggestion';

export default KoobPromptSuggestion;
